<app-topnav [pageName]="pageName"></app-topnav>

<div class="h-30"></div>
<div class="container">
  <div class="content" role="main">
    <div class="facility-heading">Add Role Training</div>
    <form #rpform="ngForm">
      <div class="designatedFacilityForm">
        <div class="form-fields">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Role</mat-label>
            <mat-select name="role" [(ngModel)]="course.role" required>
              @for (role of roles; track role.id) {
                <mat-option [value]="role.id">{{ role.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (isSubmitted && course.role === null) {
            <mat-error class="registration-validation-error">Role is required</mat-error>
          }
        </div>

        <div class="form-fields">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Title</mat-label>
            <input matInput class="form-control-textbox" [(ngModel)]="course.title" name="title" required />
          </mat-form-field>
          @if (isSubmitted && course.title === '') {
            <mat-error class="registration-validation-error">Title is required</mat-error>
          }
        </div>

        <div class="form-fields">
          <div class="toggle">
            <div class="switch-div">
              <input type="radio" name="videoSource" value="link" id="videoLink" class="active"
                [checked]="videoSource === 'link'" (change)="onVideoSourceChange('link')" />
              <label for="videoLink">Video link</label>
            </div>
            <div class="switch-div">
              <input type="radio" name="videoSource" value="upload" id="videoUpload" class="inactive"
                [checked]="videoSource === 'upload'" (change)="onVideoSourceChange('upload')" />
              <label for="videoUpload">Upload video</label>
            </div>
          </div>
        </div>

        @if (videoSource === 'link') {
          <div class="form-fields">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Video URL</mat-label>
              <input matInput class="form-control-textbox" [(ngModel)]="course.videoUrl" name="videoUrl" required placeholder="https://" />
            </mat-form-field>
            @if (isSubmitted && course.videoUrl === '') {
              <mat-error class="registration-validation-error">Video URL is required</mat-error>
            }
          </div>
        } @else {
          <div class="form-fields video-file-field">
            <label class="video-file-field__label" for="onboardingVideoFile">Video file</label>
            <input id="onboardingVideoFile" class="video-file-field__input" type="file"
              accept="video/mp4,video/webm,video/ogg,video/quicktime,.mp4,.webm,.ogg,.mov"
              (change)="onVideoSelected($event)" />
            @if (uploadedFileName) {
              <p class="answers video-file-field__meta">{{ uploadedFileName }}</p>
            }
            @if (isUploading) {
              <p class="video-file-field__meta">Uploading… {{ uploadProgress }}%</p>
            }
            @if (isSubmitted && !course.videoFileId) {
              <mat-error class="registration-validation-error">Video file is required</mat-error>
            }
          </div>
        }

        <div class="h-30"></div>
        <div class="form-fields">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Description</mat-label>
            <textarea matInput [(ngModel)]="course.description" name="description" rows="3"></textarea>
          </mat-form-field>
        </div>

        <div class="h-30"></div>
        <div>
          Status
          <div class="toggle">
            <div class="switch-div">
              <input type="radio" name="sizeBy" value="active" id="active" class="active" [(ngModel)]="courseStatus" />
              <label for="active">Active</label>
            </div>
            <div class="switch-div">
              <input type="radio" name="sizeBy" value="inactive" id="inactive" class="inactive" [(ngModel)]="courseStatus" />
              <label for="inactive">Inactive</label>
            </div>
          </div>
        </div>


        <div class="h-30"></div>
        <div>
          Requirement
          <div class="toggle">
            <div class="switch-div">
              <input type="radio" name="requirementBy" [value]="true" id="mandatory" class="active" [(ngModel)]="course.isMandatory" />
              <label for="mandatory">Mandatory</label>
            </div>
            <div class="switch-div">
              <input type="radio" name="requirementBy" [value]="false" id="optional" class="inactive" [(ngModel)]="course.isMandatory" />
              <label for="optional">Optional</label>
            </div>
          </div>
          <small>Mandatory courses must be completed before using the portal. Optional courses can be skipped.</small>
        </div>

        <div class="h-30"></div>
        <div class="order-field">
          <span class="order-field__label" id="displayOrderLabel">Display order</span>
          <div class="order-field__stepper" role="group" aria-labelledby="displayOrderLabel">
            <button type="button" class="order-field__btn" (click)="stepOrder(-1)" [disabled]="course.displayOrder <= 1" aria-label="Decrease order">−</button>
            <input class="order-field__input" type="number" min="1" step="1" name="displayOrder"
                   [(ngModel)]="course.displayOrder" (blur)="normalizeOrder()" aria-label="Display order" />
            <button type="button" class="order-field__btn" (click)="stepOrder(1)" aria-label="Increase order">+</button>
          </div>
          <small class="order-field__hint">1 is shown first, then 2, 3 and so on.</small>
        </div>

        <div class="mb-10"></div>
        <div class="form-buttons">
          <button class="submit-form-button" type="button" (click)="save(rpform)" [disabled]="isUploading || isSaving">Save</button>
          <a routerLink="/role-training-list" class="submit-form-button cancel-button">Cancel</a>
        </div>
      </div>
    </form>
  </div>
</div>
<app-footer [bbapp]="true"></app-footer>
